// Path: ./src/app/components/UploadMenuModal/styled.ts
import styled from "styled-components";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";

export const InheritTextInputField = styled(TextInputField)`
  margin-top: 5px;
  margin-bottom: 15px;
  padding: 10px;
  margin-left: 8px;
  width: 300px;
`;

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 15px 16px 20px 16px;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  margin: auto;
  border: none;
  border-right: 1px dotted grey;
  background-color: #fff;
  padding-right: 10px;
  @media (max-width: 1083px) {
    border: 0px;
  }
`;
export const ImageCard = styled.img`
  height: 293px;
  width: 293px;
  border-radius: 10px;
  box-shadow: 0px 5px 5px 0px #8888886b;
  object-fit: cover;
  object-position: center;
`;
export const ImageSubTitle = styled.div`
  padding: 4px;
  margin-top: 8px;
  font-size: 12px;
  text-transform: CAPITALIZE;
  width: 293px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  background: #fff;
`;
export const Button = styled.div`
  padding: 6px 14px 6px 14px;
  border: 2px solid #ff8038;
  border-radius: 10px;
  transition: all 0.3s;
  :hover {
    background-color: #ff8038;
    color: white;
  }
  cursor: pointer;
`;

interface PropsLocalButton {
  htmlFor?: string;
}
export const LocalButton = styled.label<PropsLocalButton>`
  padding: 6px 14px 6px 14px;
  border: 2px solid #ff8038;
  border-radius: 10px;
  transition: all 0.3s;
  :hover {
    background-color: #ff8038;
    color: white;
  }
  cursor: pointer;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 4px;
`;
export const DateWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: start;

  align-items: center;
  width: 100%;
  margin-top: 4px;
`;
export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  margin-top: 4px;
`;
export const SyncUpdateHeader = styled.div`
  width: 100%;
  background-color: #ff8038;
  text-align: center;
  color: white;
  margin-top: 10px;
  font-size: 12px;
`;
export const CheckBoxWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: 10px;
`;

export const RightSideWrapper = styled.div`
  padding-left: 16px;
  margin: auto;
  @media (max-width: 943px) {
    margin-top: 30px;
  }
`;

export const LeftSideTitle = styled.div`
  margin-left: 9px;
`;
export const RightSideTitle = styled.div`
  margin-bottom: 10px;
  margin-left: 2px;
`;
export const SalesSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
`;
export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  @media (max-width: 649px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const BottomLeftWrapper = styled.div``;

export const BottomRightWrapper = styled.div``;

export const DotDotDivider = styled.div`
  border: none;
  border-top: 1px dotted grey;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const SubmitButton = styled.div`
  background-color: #ff8038;
  padding: 6px 14px 6px 14px;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 11px;
  cursor: pointer;
  margin-top: 10px;
  @media (max-width: 649px) {
    height: 50px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 15px;
  }
`;

export const RegularPrice = styled.div``;
export const RegularPriceTitle = styled.div``;

export const FlyerImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 290px;
  height: 293px;
  overflow-y: scroll;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const SmallImageWrapper = styled.div`
  margin-left: 10px;
  margin-top: 10px;
`;

export const UnitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 649px) {
    flex-direction: column;
    align-items: start;
    margin-bottom: 10px;
  }
`;

export const RankInputField = styled(TextInputField)`
  padding: 7px;
`;
export const RankTitle = styled.div`
  margin-right: 10px;
  @media (max-width: 649px) {
    margin-bottom: 5px;
  }
`;

export const RankWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 10px;
  @media (max-width: 649px) {
    flex-wrap: wrap;
  }
`;
